export const roofAndMirrorCaps = ({ roofAndMirrorCaps }) =>
  roofAndMirrorCaps.byId;
